module.exports = __webpack_public_path__ + "img/status_icon_success.72c62d80.svg";